import { Box, useMediaQuery, useTheme } from '@mui/material';
import NotificationBox from '@/components/global/fields/NotificationBox.jsx';
import { useTranslate } from 'react-admin';

export const AdsNotificationBox = () => {
    const translate = useTranslate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <>
            {!isMobile && (
                <Box>
                    <NotificationBox variant='info' className='large ads-campaigns-notification'>
                        {translate('notification.ads.info')}
                    </NotificationBox>
                </Box>
            )}
        </>
    );
};
